<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Company Group Component
        <p class="pl-4">|</p>
      </h1>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="success"
        type="filled"
        icon="add"
        @click="cusAdd"
        v-if="btndis"
        >Add</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis2"
        >Edit</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis2"
        >Delete</vs-button
      >
      <p class="pr-4"></p>
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <expadd
        v-if="addshow"
        :key="addshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
      ></expadd>
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        @recsel="recsel"
        @mousedown.middle.native="getXY"
      ></aggrid>
    </transition-group>
  </div>
</template>

<script>
import aggrid from "./grid";
import expadd from "./exp_add.vue";

import axios from "axios";
import { BASE_API_URL} from "@/constants/index.ts";

export default {
  data() {
    return {
      viewshow: false,
      btndis2: false,
      addshow: false,
      gridshow: false,
      btndis: true,
      recid: "0",
      acstate: null,
      userid:'',
      addressCode: null,
      custGroupsCode: null,
    };
  },
  methods: {
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val) {
      // console.log(val);
      this.btndis = true;
      this.btndis2 = true;
      this.recid = val;
    },
    // recsel(val, val2) {
    //   // console.log(val);
    //   this.btndis = true;
    //   this.recid = val;
    //   if (val2 == "INBOUND_COMPLETE") {
    //     this.btndis2 = false;
    //   } else {
    //     this.btndis2 = true;
    //   }
    // },
    goDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth();
      let yyyy = today.getFullYear();
      let months_th = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];

      if (dd < 10) {
        dd = "0" + dd;
      }

      // if (mm < 10) {
      //   mm = "0" + mm;
      // }
      this.daday = dd;
      this.damonth = months_th[mm];
      this.dayear = Number(yyyy) + 543;
      this.dtoday = dd + "-" + mm + "-" + yyyy;
    },
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.btndis2 = false;
      this.acstate = "ADD";
    },
    grid() {
      this.addshow = false;
      this.gridshow = true;
      this.btndis = true;
      this.btndis2 = false;
      // this.$store.dispatch("setReportGrid", 0);
    },
    cusEdit() {
      this.addshow = true;
      this.gridshow = false;
      this.btndis2 = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert
      });
    },
    async acceptAlert() {
      // this.btndis = false;
      this.btndis2 = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {

          const formData = {
            code: this.recid,
            editor: String(this.userid),
          };

          const response = await axios.post(
            `${BASE_API_URL}/auth-svc/companygroups/delete`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status!='success') {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        this.$router.replace("/pages/login/");
      }
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;
          this.email = decoded.email;
          this.addressCode = decoded.addressCode;
          this.custGroupsCode = decoded.custGroupsCode;

        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  mounted() {
    this.checkProfiles();
  },
  components: {
    aggrid,
    expadd
  }
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
